<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-truck"></i></span>{{ 'ForwarderSetting.Title' |
    translate }}</h1>
  <p-card class="mx-2">
    <p-tabView [(activeIndex)]="selectedTabIndex">
      <p-tabPanel header="{{ 'ForwarderSetting.ExportRecommendForwarder.Titel' | translate }}">
        <forwarder-setting-export></forwarder-setting-export>
      </p-tabPanel>
      <p-tabPanel header="{{ 'ForwarderSetting.LocalRecommendForwarder.Title' | translate }}">
        <laas-forwarder-setting-local></laas-forwarder-setting-local>
      </p-tabPanel>
      <p-tabPanel header="{{ 'ForwarderSetting.RMBRecommendForwarder.Titel' | translate }}">
        <forwarder-setting-rmb></forwarder-setting-rmb>
      </p-tabPanel>
    </p-tabView>
  </p-card>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
